'use client';

import { memo } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useTranslation } from '@/kit/useTranslation';

/**
 * Address route section showing From → To
 */
const AddressSection = memo(({ fromAddress, toAddress }) => {
  const { t } = useTranslation();

  const getAddressLabel = (address) => {
    if (!address) return t('bookingDetails.na');
    if (typeof address === 'string') return address;
    if (typeof address === 'object') {
      return (
        address.fullAddress ||
        address.address ||
        address.label ||
        address.city ||
        t('bookingDetails.addressNotAvailable')
      );
    }
    return t('bookingDetails.na');
  };
  return (
    <Stack spacing={1.5}>
      {/* From */}
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: '#4caf50',
            flexShrink: 0,
          }}
        />
        <Box flex={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: 10,
              textTransform: 'uppercase',
              fontWeight: 600,
              letterSpacing: 0.5,
            }}
          >
            {t('bookingDetails.from')}
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14, lineHeight: 1.4 }}>
            {getAddressLabel(fromAddress)}
          </Typography>
        </Box>
      </Stack>

      {/* To */}
      <Stack direction="row" spacing={1.5} alignItems="center">
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: '#f44336',
            flexShrink: 0,
          }}
        />
        <Box flex={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontSize: 10,
              textTransform: 'uppercase',
              fontWeight: 600,
              letterSpacing: 0.5,
            }}
          >
            {t('bookingDetails.to')}
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ fontSize: 14, lineHeight: 1.4 }}>
            {getAddressLabel(toAddress)}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
});

AddressSection.displayName = 'AddressSection';

export default AddressSection;
